import {
  FetchForgotPasswordReducer,
  FetchResetPasswordReducer,
  LoginReducer,
} from "../slices/loginReducer";
import {
  FarmerCreateReducer,
  FarmerGetReducer,
  FarmerInspectionListReducer,
  FarmerHarvestingListReducer,
  FarmerDetailsById,
  FarmerCreateInspectionReducer,
  FarmerCreateHarvestingReducer,
  FarmerUpdateInspectionReducer,
  FarmerUpdateHarvestingReducer,
  FarmerUpdateDetailsReducer,
  FarmerPhotoReducer,
  FarmerSendToFermentationReducer,
} from "../slices/farmerReducer";
import {
  UserGetReducer,
  UserUpdateReducer,
  ChangePasswordReducer,
  UserListReducer,
  UserPhotoReducer,
  UserCreateReducer,
  GetQuicksightEmbedUrlReducer,
} from "../slices/userReducer";
import {
  ChemistryLogsListReducer,
  ChemistryLogsReducer,
  ChemistryLogsUpdateReducer,
  FermentationCreateReducer,
  FermentationDetailsByIdReducer,
  FermentationGetReducer,
  FermentationUpdateReducer,
  TankListReducer,
  TankDetailsByIdReducer,
} from "../slices/fementationReducer";
import {
  AddNewStrippingReducer,
  AddStrippingProcessDataByIdReducer,
  AddSubLogReducer,
  AddWasteWaterReducer,
  DeleteSubLogReducer,
  GetStrippingProcessByIdReducer,
  GetStrippingProcessDataByIdReducer,
  GetStrippingProcessDataReducer,
  GetStrippingProcessListReducer,
  GetSubLogListReducer,
  GetWasteWaterListReducer,
  SendToStrippingProcessReducer,
  UpdateStrippingProcessByIdReducer,
  UpdateStrippingProcessDataByIdReducer,
  UpdateSubLogReducer,
  UpdateWasteWaterReducer,
} from "../slices/strippingProcessReducer";
import {
  AddSpiritLogsDataReducer,
  AddSpiritWasteWaterReducer,
  CreateSpiritReducer,
  DeleteSpiritLogReducer,
  GetSpiritProcessByIdReducer,
  GetSpiritProcessDataReducer,
  GetSpiritProcessListReducer,
  GetSpiritWasteWaterListReducer,
  SendToSpiritProcessReducer,
  UpdateSpiritLogsByIdReducer,
  UpdateSpiritProcessByIdReducer,
  UpdateSpiritWasteWaterReducer,
  GetEndOfRunCutReducer,
  SaveEndOfRunCutReducer,
  DeleteSpiritWasteWaterReducer,
} from "../slices/spiritProcessReducer";
import {
  AddProofingReducer,
  DeleteProofingLogReducer,
  GetProofingListReducer,
  GetSpiritListAssociateProofingReducer,
  SendToProofingReducer,
  UnlinkSpiritWithProofingReducer,
  UpdateProofingReducer,
} from "../slices/proofingReducer";
import {
  AddCaskAndAgingReducer,
  AddSamplinglogsReducer,
  GetCaskAndAgingByIdReducer,
  GetCaskAndAgingListReducer,
  GetSampingLogsListReducer,
  UpdateCaskAndAgingReducer,
  UpdateSamplinglogsReducer,
  AddCaskOpenLogsReducer,
  UpdateCaskOpenLogsReducer,
  GetCaskOpenLogsListReducer,
  GetCaskOpenLogsByIdReducer,
  DeleteCaskOpenLogsReducer,
} from "../slices/caskAndAgingReducer";
import {
  AddCaskMasterReducer,
  GetCaskMasterListReducer,
  UpdateCaskMasterReducer,
} from "../slices/caskMasterReducer";
import {
  AddBottlingReducer,
  DeleteBottlingFromSubListReducer,
  GetBottlingListReducer,
  GetBottlingSubListReducer,
  UpdateBottlingReducer,
} from "../slices/bottlingReducer";
import {
  AddCaneVarietyReducer,
  GetCaneVarietyListReducer,
  UpdateCaneVarietyReducer,
} from "../slices/caneVarietyReducer";
import {
  AddRumTypeReducer,
  GetRumTypeListReducer,
  UpdateRumTypeReducer,
} from "../slices/rumTypeReducer";
import {
  AddNutrientReducer,
  GetNutrientsListReducer,
  UpdateNutrientReducer,
} from "../slices/nutrientsReducer";
import {
  DeleteSupplierReducer,
  SupplierCreateReducer,
  SupplierGetReducer,
  SupplierListReducer,
  SupplierUpdateReducer,
  UploadFileReducer,
} from "../slices/supplierReducer";
import {

  FermentationOptions,
  MolassesCreateReducer,
  MolassesGetReducer,
  MolassesListReducer,
  MolassesUpdateReducer,
  SendToFermentationReducer,
  getMolasses,
} from "../slices/molassesReducer";

const rootReducer = {
 // getBreadcrumbs: Breadcrumbs,
  // Auth
  login: LoginReducer,
  forgotPassword: FetchForgotPasswordReducer,
  resetPassword: FetchResetPasswordReducer,
  // Auth

  // User
  createUser: UserCreateReducer,
  getUser: UserGetReducer,
  updateUser: UserUpdateReducer,
  userPhoto: UserPhotoReducer,
  changePassword: ChangePasswordReducer,
  getUserList: UserListReducer,
  getQuicksightEmbedUrl: GetQuicksightEmbedUrlReducer,
  // User

  // Farmer
  createFarmer: FarmerCreateReducer,
  getFarmer: FarmerGetReducer,
  updateFarmer: FarmerUpdateDetailsReducer,
  farmerPhoto: FarmerPhotoReducer,
  createInspection: FarmerCreateInspectionReducer,
  updateInspection: FarmerUpdateInspectionReducer,
  getInspectionList: FarmerInspectionListReducer,
  createFarmHarvesting: FarmerCreateHarvestingReducer,
  getHarvestingList: FarmerHarvestingListReducer,
  updateHarvesting: FarmerUpdateHarvestingReducer,
  getFarmerDetailsById: FarmerDetailsById,
  sendToFermentation1: FarmerSendToFermentationReducer,
  // Farmer

  // Fermentation Start
  getFermentation: FermentationGetReducer,
  createFermentation: FermentationCreateReducer,
  getFermentationDetailsById: FermentationDetailsByIdReducer,
  updateFermentation: FermentationUpdateReducer,
  createChemistryLogs: ChemistryLogsReducer,
  getChemistryLogsList: ChemistryLogsListReducer,
  updateChemistryLogs: ChemistryLogsUpdateReducer,
  getTankList: TankListReducer,
  getTankDetailsById: TankDetailsByIdReducer,
  // Fermentation Start

  // Supplier Start
  getSupplierList: SupplierListReducer,
  createSupplier: SupplierCreateReducer,
  getSupplier: SupplierGetReducer,
  updateSupplier: SupplierUpdateReducer,
  uploadFile: UploadFileReducer,
  deleteSupplier: DeleteSupplierReducer,
  // Supplier End

  // Molasses Start
  getMolassesList: MolassesListReducer,
  createMolasses: MolassesCreateReducer,
  getMolasses: MolassesGetReducer,
  updateMolasses: MolassesUpdateReducer,
  getFermentationOptions: FermentationOptions,
  sendToFermentation: SendToFermentationReducer,
  // Molasses End

  // Stripping Start
  addNewStrippingProcess: AddNewStrippingReducer,
  getStrippingProcessList: GetStrippingProcessListReducer,
  getStrippingProcessByIdData: GetStrippingProcessByIdReducer,
  getStrippingProcessData: GetStrippingProcessDataReducer,
  updateStrippingProcessById: UpdateStrippingProcessByIdReducer,
  updateStrippingProcessDataById: UpdateStrippingProcessDataByIdReducer,
  addStrippingProcessDataById: AddStrippingProcessDataByIdReducer,
  getStrippingProcessDataById: GetStrippingProcessDataByIdReducer,
  sendToStrippingProcess: SendToStrippingProcessReducer,
  addWasteWater: AddWasteWaterReducer,
  updateWasteWater: UpdateWasteWaterReducer,
  getWasteWaterList: GetWasteWaterListReducer,
  addSubLog: AddSubLogReducer,
  updateSubLog: UpdateSubLogReducer,
  getSubLogListList: GetSubLogListReducer,
  deleteSubLog: DeleteSubLogReducer,
  
  // Stripping End

  // Spirit Start
  createSpirit: CreateSpiritReducer,
  getSpiritProcessList: GetSpiritProcessListReducer,
  getSpiritProcessById: GetSpiritProcessByIdReducer,
  updateSpiritProcessById: UpdateSpiritProcessByIdReducer,
  addSpiritLogsData: AddSpiritLogsDataReducer,
  updateSpiritLogsById: UpdateSpiritLogsByIdReducer,
  deleteSpiritLog: DeleteSpiritLogReducer,
  getSpiritProcessData: GetSpiritProcessDataReducer,
  addSpiritWasteWater: AddSpiritWasteWaterReducer,
  updateSpiritWasteWater: UpdateSpiritWasteWaterReducer,
  deleteSpiritWasteWater: DeleteSpiritWasteWaterReducer,
  getSpiritWasteWaterList: GetSpiritWasteWaterListReducer,
  sendToSpiritProcess: SendToSpiritProcessReducer,
  getEndOfRunCut: GetEndOfRunCutReducer,
  saveEndOfRunCut: SaveEndOfRunCutReducer,
  // Spirit End

  // Proofing Start
  addProofing: AddProofingReducer,
  updateProofing: UpdateProofingReducer,
  deleteProofingLog: DeleteProofingLogReducer,
  getProofingList: GetProofingListReducer,
  sendToSpiritProofing: SendToProofingReducer,
  unlinkSpiritWithProofing: UnlinkSpiritWithProofingReducer,
  getSpiritListAssociateProofing: GetSpiritListAssociateProofingReducer,
  // Proofing End

  // CaskAndAging Start
  addCaskAndAging: AddCaskAndAgingReducer,
  updateCaskAndAging: UpdateCaskAndAgingReducer,
  getCaskAndAgingList: GetCaskAndAgingListReducer,
  getCaskAndAgingById: GetCaskAndAgingByIdReducer,
  addSamplinglogs: AddSamplinglogsReducer,
  updateSamplinglogs: UpdateSamplinglogsReducer,
  getSampingLogsList: GetSampingLogsListReducer,
  addCaskOpenLogs: AddCaskOpenLogsReducer,
  updateCaskOpenLogs: UpdateCaskOpenLogsReducer,
  getCaskOpenLogsList: GetCaskOpenLogsListReducer,
  getCaskOpenLogsById: GetCaskOpenLogsByIdReducer,
  deleteCaskOpenLogs: DeleteCaskOpenLogsReducer,
  // CaskAndAging End

  // CaskMaster Start
  addCaskMaster: AddCaskMasterReducer,
  updateCaskMaster: UpdateCaskMasterReducer,
  getCaskMasterList: GetCaskMasterListReducer,
  // CaskMaster End

  // Bottling Start
  addBottling: AddBottlingReducer,
  updateBottling: UpdateBottlingReducer,
  getBottlingList: GetBottlingListReducer,
  getBottlingSubList: GetBottlingSubListReducer,
  deleteBottlingFromSubList: DeleteBottlingFromSubListReducer,
  // Bottling End

  // CaskAndAging Start
  addCaneVariety: AddCaneVarietyReducer,
  updateCaneVariety: UpdateCaneVarietyReducer,
  getCaneVarietyList: GetCaneVarietyListReducer,
  // CaskAndAging End

  // RumType Start
  addRumType: AddRumTypeReducer,
  updateRumType: UpdateRumTypeReducer,
  getRumTypeList: GetRumTypeListReducer,
  // RumType End

  // Nutrients Start
  addNutrients: AddNutrientReducer,
  updateNutrients: UpdateNutrientReducer,
  getNutrientsList: GetNutrientsListReducer,
  // Nutrients End
};

export default rootReducer;
